var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-1" },
    [
      _c("div", [
        _c("div", { staticClass: "data-name" }, [
          _vm._v(_vm._s(_vm._f("empty")(_vm.value.description)))
        ])
      ]),
      _c(
        "validation-observer",
        { ref: `answers-${_vm.value.id}` },
        [
          _c(
            "div",
            { staticClass: "my-3" },
            _vm._l(_vm.groupedOptions, function(item) {
              return _c(
                "div",
                { key: item.key },
                [
                  _c("validation-provider", {
                    attrs: {
                      name: `answers-${item.key}-checks`,
                      rules: "checks"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("options-panel", {
                                attrs: {
                                  data: { options: item?.options || [] },
                                  "has-container-panel": false,
                                  "is-other-large": "",
                                  "is-read-only": _vm.isReadOnly,
                                  "is-vertical": "",
                                  "option-col": "col-3 py-3",
                                  "show-header": false
                                },
                                model: {
                                  value: item.options,
                                  callback: function($$v) {
                                    _vm.$set(item, "options", $$v)
                                  },
                                  expression: "item.options"
                                }
                              }),
                              errors[0]
                                ? _c("error", {
                                    staticClass: "mt-3",
                                    attrs: {
                                      message: "Seleccione al menos una opción",
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  item.key < _vm.groupedOptions.length ? _c("hr") : _vm._e()
                ],
                1
              )
            }),
            0
          ),
          _vm._l(_vm.others, function(otherItem) {
            return _c(
              "div",
              { key: otherItem.id, staticClass: "my-3" },
              [
                _c("label", { staticClass: "data-name" }, [
                  _vm._v(_vm._s(otherItem.name) + ":")
                ]),
                _vm.isReadOnly
                  ? _c("p", [_vm._v(_vm._s(_vm._f("empty")(otherItem.other)))])
                  : _c("validation-provider", {
                      attrs: {
                        name: `answers-${_vm.value.id}-${otherItem.id}-comment`,
                        rules: "required"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": ""
                                  },
                                  model: {
                                    value: otherItem.other,
                                    callback: function($$v) {
                                      _vm.$set(otherItem, "other", $$v)
                                    },
                                    expression: "otherItem.other"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }